function e(e){const t=function(e){const t=document.createElement("textArea");return t.readOnly=!0,t.value=e,document.body.appendChild(t),t}(e);t.select(),document.execCommand("copy"),document.body.removeChild(t)}export{e as copyToClipboard,e as default};
//# sourceMappingURL=clipboard.js.map
